/** @format */

import React from "react";

const Mission = () => {
  return (
    <div className="mission content" id="mission">
      <h1>Our Mission</h1>
      <section className="text">
        Since the beginning of Soul4English, we've aimed to ensure that as many
        non-native English speakers learn to read, write, and speak English as
        fluently as possible. We accept students of all levels in hopes of
        offering courses from which every student can gain knowledge. With our
        certified teachers and vast resources used to bring students the best
        learning experience suited for their needs, we consider it a privilege
        to help others. If you're interested in enrolling, please email us at
        soul4english@gmail.com.
      </section>
    </div>
  );
};

export default Mission;
